import { createApp } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import router from './index';
import { initAnalytics } from './analytics.js';
import { initAuthStore } from './stores/authStore.js';
import VueApexCharts from 'vue3-apexcharts';

loadFonts()
initAnalytics()
initAuthStore()

createApp(App)
  .use(vuetify)
  .use(router)
  .use(VueApexCharts)
  .component('apexchart', VueApexCharts)
  .mount('#app')
